import { applyOpeningCutsToFoundationHorizontalAssemblies } from "building-generation/elements/foundation/foundationOpeningCuts";
import type { Building } from "building-types/building/buildingTypes";
import type { GeneratedFoundationHorizontalAssemblySubSystem } from "building-types/foundations/foundationTypes";
import type { Table } from "common/data/table";
import makeGenerationStageComparator from "../utils/makeGenerationStageComparator";
import memo from "../utils/memo";

function select({ foundationHorizontalAssemblies, doorPlacements, windowPlacements, settings }: Building) {
  return {
    foundationHorizontalAssemblies,
    doorPlacements,
    windowPlacements,
    doorSettings: settings.door,
  };
}

const compare = makeGenerationStageComparator<typeof select>({
  foundationHorizontalAssemblies: "shallow",
  doorPlacements: "shallow",
  windowPlacements: "shallow",
  doorSettings: "shallow",
});

function generate(input: ReturnType<typeof select>): {
  foundationHorizontalAssemblies: Table<GeneratedFoundationHorizontalAssemblySubSystem>;
} {
  const { foundationHorizontalAssemblies, doorPlacements, windowPlacements, doorSettings } = input;

  if (!foundationHorizontalAssemblies || Object.keys(foundationHorizontalAssemblies).length === 0) {
    return { foundationHorizontalAssemblies: foundationHorizontalAssemblies ?? {} };
  }

  if (!doorPlacements && !windowPlacements) {
    return { foundationHorizontalAssemblies };
  }

  return {
    foundationHorizontalAssemblies: applyOpeningCutsToFoundationHorizontalAssemblies({
      foundations: foundationHorizontalAssemblies,
      doorPlacements: doorPlacements ?? {},
      windowPlacements: windowPlacements ?? {},
      doorSettings,
    }),
  };
}

export default memo(select, generate, compare);
